import { NavigateFunction, useNavigate } from 'react-router-dom'
import { useShop } from 'shop/hooks'
import ErrorModal from 'shop/components/Modal/ErrorModal'

const cartErrorGlossary = (
  errorCode: string,
  storeName: string | null,
  navigate: NavigateFunction
): {
  title: string
  messages: string[]
  buttonMessage: string
  handleButtonClick: () => void
} => {
  return {
    title: 'Oops, something has gone wrong',
    messages: [
      'We have encountered an unexpected problem. Please go back and try again.'
    ],
    buttonMessage: 'Try again',
    handleButtonClick: () => navigate('/')
  }
}

interface CartErrorModalProps {
  errorCode: string
}

const CartErrorModal = ({ errorCode }: CartErrorModalProps) => {
  const navigate = useNavigate()
  const { currentPartnerStore } = useShop()
  const { name: storeName = '' } = currentPartnerStore || {}

  return (
    <ErrorModal
      errorCode={errorCode}
      errorTitle={cartErrorGlossary(errorCode, storeName, navigate).title}
      errorMessages={cartErrorGlossary(errorCode, storeName, navigate).messages}
      primaryButton={{
        message: cartErrorGlossary(errorCode, storeName, navigate)
          .buttonMessage,
        onClick: cartErrorGlossary(errorCode, storeName, navigate)
          .handleButtonClick
      }}
    />
  )
}

export default CartErrorModal
